import axios from 'axios'
import auth from '@/plugins/api/users/auth'
const ENDPOINT_WISHLIST = auth.api.endpointPath + 'wishlists'
export default {
    getWishList(pill = null){

        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        const id = sessionStorage.getItem('user_id')
        const params = {
            'user.id': id,
        };
        if (pill) {
            params['pill.id'] = pill.id
        }

        return axios.get(ENDPOINT_WISHLIST, { params: params })
    },

    deleteWishList(wishlist) {
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        return axios.delete(ENDPOINT_WISHLIST+ '/' + wishlist.id)
    },
    createWishList(pill){
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        const user_id = sessionStorage.getItem('user_id')
        const params = {
            'user': "/api/v1/users/"+user_id,
            'pill': pill["@id"]
        };
        return axios.post(ENDPOINT_WISHLIST, params)
    }
}
